<template>
  <div class="sogym__menu">
    <transition name="fade" tag="div" mode="out-in">
      <div style="display: flex;justify-content: center" >
        <a class="news" href="#" v-if="news[0]" key="0">15 кг ЕТ АЛСАҢЫЗ 1 кг ВАРЕНИКИ ТЕГІН!</a>
        <a class="news" href="#" v-if="news[1]" key="2">ӘР ЖҰМА - ЖОМАРТ ЖҰМА! етке -100 теңге жеңілдік</a>
      </div>
    </transition>


    <div style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start;text-align: center">
      <p class="sogym__menu--title">SOGYM</p>
      <p class="sogym__menu--subtitle">halal</p>
      <p class="sogym__menu--subtitle">et ortalygy</p>
      <p class="sogym__menu--sites">halalsogym.kz</p>

<!--      <p class="sogym__menu&#45;&#45;site">halalsogym.kz</p>-->

    </div>


    <div class="sogym__menu--inner" v-for="(productList,index) in allProducts" :key="index">
        <p class="sogym__menu-category" v-if="productList.data[0]"> {{ productList.data[0].category.name }} </p>
        <div class="sogym__menu-text" >
          <div v-for="(item,index2) in chunkArray(productList.data) " :key="index2">
            <div class="item__row item__ac" style="display: flex;flex-direction: row">
              <p class="sogym__menu-left-text" v-if="item[0]">{{ item[0].name }}    &nbsp;      <span class="sogym__menu-value"> {{ item[0].price }} tg</span></p>
              <p class="sogym__menu-right-text" v-if="item[1]">{{ item[1].name }}   &nbsp;      <span class="sogym__menu-value"> {{ item[1].price }} tg</span></p>
            </div>
          </div>
        </div>
    </div>
    <img class="meat__chalk--second"  src="../../assets/images/meat__chalk2.png" alt="">
  </div>

</template>


<script>

export default {
  data () {
    return {
      news: [
        true,
        false,
        false,
        false
      ],
      allProducts: [],
      categories: [],
      comments: [
        {
          id: 1,
          title: '@aigul_kazhenbay',
          text : 'Спасибо за моментальную доставку мы за оперативность',
          star : 5
        },
        {
          id: 2,
          title: '@taganovazhaniia',
          text : 'Фарш таза өте дәмді',
          star : 5
        },
        {
          id: 3,
          title: '@klaraturniiazova',
          text : 'Фарш у них отличное',
          star : 5
        },
        {
          id: 4,
          title: '@serik_km_kz',
          text : 'Еттерің жақсы екен! Алла разы болсын',
          star : 5
        }
      ]
    }
  },
  created: function() {
    setInterval(this.updateTicker, 4000);
  },
  methods: {
    updateTicker: function() {
      let removed = this.news.pop();
      this.news.unshift(removed);
    },
    getCategories() {
      this.categories = []
      const config = {
        headers: { Authorization: `Bearer ${this.token}` },
      };
      this.$http.get("/get/all/categories", config).then((res) => {
        this.categories = res.data;
        this.getProducts()
      });
    },
     async getProducts() {
      this.allProducts = [];
      for (let i = 0; i < this.categories.length; i++) {
        await this.$http.post("guest/get/products/by/category",
            {
          per_page: 50,
          category_id: this.categories[i].id
        }).then((res) => {
          this.allProducts.push(res.data)
        });
      }


    },
    chunkArray(array) {
      const perChunk = 2 // items per chunk
      const inputArray = array
      const result = inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index/perChunk)

        if(!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [] // start a new chunk
        }

        resultArray[chunkIndex].push(item)

        return resultArray
      }, [])
      return result
    }
  },
  computed: {
  },
  mounted() {
    this.getCategories()
  }

}
</script>

<style lang="scss">
.news {
  color: white !important;
  font-size: 46px;
  font-weight: bold;
  text-decoration: none;
  position: fixed;
  top: -5px;
  font-family: 'MontserratExtraBold' !important;
}
.sogym__menu {
  background: #2a2d34;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 70px solid #ee612e;
  flex-direction: column;

  .sogym__menu--sites {
    position: fixed;
    color: white;
    font-size:32px;
    top: 250px;
    right: 50px;

    transform: rotate(30deg);
    font-family: 'Chalk' !important;
  }
  .sogym__menu--title {
    text-align: center;
    line-height: 1;
    color: white;
    font-size: 105px;
    font-weight: bold;
    font-family: 'Chalk' !important;
    margin-bottom: 0;
    transform: rotate(30deg);
    position: fixed;
    top: 300px;
    right: 50px;
  }
  .sogym__menu--subtitle {
    text-align: center;
    line-height: 1;
    color: white;
    font-size: 55px;
    font-weight: bold;
    font-family: 'Chalk' !important;
    margin-bottom: 0;
    transform: rotate(30deg);
    position: fixed;
    top: 450px;
    right: 100px;
  }
  .sogym__menu--site {
    text-align: center;
    line-height: 1;
    color: white;
    font-size: 45px;
    font-weight: bold;
    font-family: 'Chalk' !important;
    margin-bottom: 0;
    transform: rotate(30deg);
    position: fixed;
    bottom: 200px;
    left: 100px;
  }
  .sogym__menu-category {
    color: white;
    font-size: 26px;
    text-transform: uppercase;
    font-weight: bold;
  }
  .sogym__menu--inner {
    text-align: center;
  }
  .sogym__menu-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: white;

    font-weight: bold;
    p {
      font-size: 30px;
    }
  }
  .sogym__menu-left-text {
    width: 380px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    white-space: nowrap;
    font-weight: bold;

  }
  .sogym__menu-right-text {
    width: 400px;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    white-space: nowrap;
    font-weight: bold;

  }
  .sogym__menu-value {
    color: #ee612e;
    font-weight: bold;
    font-size: 32px;
    font-family: 'Chalk' !important;
  }
  .meat__chalk--first {
    position: fixed;
    top: 2px;
    left: 20px;
    width: 20%;
  }

  .meat__chalk--second {
    position: fixed;
    bottom: -50px;
    right: 20px;
    width: 20%;
  }
}
</style>